export const canchas = [
    { name: "Villa Mitre 1" },
    { name: "Villa Mitre 2" },
    { name: "Tiro Federal 1" },
    { name: "Tiro Federal 2" },
    { name: "Olimpo 1" },
    { name: "Olimpo 2" },
    { name: "Olimpo 3" },
    { name: "Bahiense del Norte 2" },
    { name: "Bahiense del Norte 3" },
    { name: "Comercial" },
    { name: "Independiente" }
];